var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRecycleGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83379 15.8333H4.01296C3.7501 15.8341 3.4915 15.7669 3.26227 15.6383C3.03303 15.5096 2.84094 15.3239 2.70462 15.0992C2.57372 14.8734 2.5045 14.6172 2.50391 14.3563C2.50332 14.0953 2.5714 13.8388 2.70129 13.6125L5.99712 7.91667M5.99712 7.91667L6.91129 11.33M5.99712 7.91667L2.58379 8.83167M9.16712 15.8333H16.003C16.2646 15.8313 16.5212 15.762 16.7483 15.6321C16.9754 15.5023 17.1653 15.3161 17.2996 15.0917C17.4287 14.8666 17.4966 14.6116 17.4966 14.3521C17.4966 14.0926 17.4287 13.8376 17.2996 13.6125L16.278 11.8458M9.16712 15.8333L11.6671 13.3333M9.16712 15.8333L11.6671 18.3333M7.78712 4.8425L8.69796 3.26584C8.82875 3.03783 9.01625 2.84751 9.24227 2.71332C9.4683 2.57914 9.72517 2.50566 9.98796 2.5C10.2487 2.49952 10.5051 2.56764 10.7312 2.69752C10.9573 2.82741 11.1453 3.0145 11.2763 3.24L14.5621 8.9425M14.5621 8.9425L11.1488 8.0275M14.5621 8.9425L15.4763 5.52917",
    stroke: "#A9A9A9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecycleGrey);
export default __webpack_public_path__ + "static/media/icon-recycle-grey.0886a297e7f0f67a20b9ba37fe424593.svg";
export { ForwardRef as ReactComponent };